var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maintenance-container"},[_c('img',{staticClass:"maintenance-image",attrs:{"src":"https://assets-intranet-security.s3.us-east-2.amazonaws.com/MANTENCION_MI-SECURITY-15-11-2024.png","alt":"Mantenimiento"}})])
}]

export { render, staticRenderFns }